import React from 'react';
import PropTypes from 'prop-types';
import { actions as notify } from 'redux-notifications';
import api from '../../../apiSingleton';
import { showAuthModal as showAuthForm } from '../../../app/Auth/actions';
import { updateStatistic } from '../../../app/Favorites/actions';

class FavoriteBase extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      active: props.active
    };

    this.id = props.itemId;
    this.handlerAdd = this.handlerAdd.bind(this);
    this.handlerRemove = this.handlerRemove.bind(this);
  }

  handlerAdd (e) {
    const {userId, dealType, realtyType, dispatch, eventAddFavorites, eventAddFavoritesForCian} = this.props;

    eventAddFavorites();
    eventAddFavoritesForCian();
    e.preventDefault();
    e.stopPropagation();

    if (userId) {
      api.user
        .favoritesAdd(userId, dealType, realtyType, this.id)
        .then((resp) => {
          this.setState({active: true});

          dispatch(updateStatistic(resp));
          dispatch(notify.notifSend({
            message: 'Добавленно в избранное',
            dismissAfter: 2000
          }));
        });
    } else {
      // this.props.dispatch(showAuthForm('signin'));
      dispatch(showAuthForm(
        'Для добавления объявления в избранное необходимо авторизоваться или зарегистрироваться. <br /><br />' +
        'Это позволит вам видеть один и тот же список на любых ваших устройствах.'));
    }
  }

  handlerRemove (e) {
    const {userId, dealType, realtyType, dispatch, eventRemoveFavorites, eventRemoveFavoritesForCian} = this.props;

    eventRemoveFavorites();
    eventRemoveFavoritesForCian();
    e.preventDefault();
    e.stopPropagation();

    api.user
      .favoritesRemove(userId, dealType, realtyType, this.id)
      .then((resp) => {
        this.setState({active: false});

        dispatch(updateStatistic(resp));
        dispatch(notify.notifSend({
          message: 'Удалено из избранного',
          dismissAfter: 2000
        }));
      });
  }

  shouldComponentUpdate (nextProps, nextState, nextContext) {
    return nextState.active !== this.state.active;
  }
}

FavoriteBase.propTypes = {
  dispatch: PropTypes.func.isRequired,
  userId: PropTypes.number,
  active: PropTypes.bool.isRequired,
  itemId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  dealType: PropTypes.string.isRequired,
  realtyType: PropTypes.string.isRequired,

  eventAddFavorites: PropTypes.func,
  eventRemoveFavorites: PropTypes.func,
  eventAddFavoritesForCian: PropTypes.func,
  eventRemoveFavoritesForCian: PropTypes.func
};

FavoriteBase.defaultProps = {
  userId: null,
  eventAddFavorites: () => {},
  eventRemoveFavorites: () => {},
  eventAddFavoritesForCian: () => {},
  eventRemoveFavoritesForCian: () => {}
};

export default FavoriteBase;



// WEBPACK FOOTER //
// ./src/ui/Controls/Favorite/FavoriteBase.jsx